import AssessmentResults from "pages/PanelPage/components/selectedAssessment/assessmentResults/AssessmentResults/AssessmentResults";

export default AssessmentResults;
